import SearchBarButton from "./SearchBarButton";
import SearchBarInput from "./SearchBarInput";

interface ISearchBarProps {
  className?: string;
  placeholderText?: string;
  ariaLabel?: string;
  searchInput: string;
  setSearchInput: (value: string) => void;
  onClickSearch: () => void;
  buttonLabel?: string;
  buttonIconColor?: string;
}



const SearchBar = ({className = "", placeholderText, ariaLabel, searchInput, setSearchInput, onClickSearch, buttonLabel, buttonIconColor}: ISearchBarProps) => {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            onClickSearch();
        }
    };

    return (
        <div className={`thrive-component-search-bar-wrapper ${className}`}>
            <SearchBarInput 
                placeholderText={placeholderText}
                ariaLabel={ariaLabel}
                searchInput={searchInput}
                setSearchInput={setSearchInput}
                handleKeyDown={handleKeyDown}
            />

            <SearchBarButton 
                onClickButton={onClickSearch}    
                buttonLabel={buttonLabel} 
                iconColor={buttonIconColor} 
            />
        </div>
    );
};

export default SearchBar;